import React from 'react'

interface ShareProps {
  className?: string
}

const Share: React.FC<ShareProps> = ({ className }: ShareProps) => (
  <svg
    className={className}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="share-ios-2">
      <g id="Group 2621">
        <path
          id="Rectangle 380"
          d="M12.916 7.5H13.166C14.0994 7.5 14.5661 7.5 14.9227 7.68166C15.2363 7.84144 15.4912 8.09641 15.651 8.41002C15.8327 8.76654 15.8327 9.23325 15.8327 10.1667V14.1667C15.8327 15.3334 15.8327 15.9168 15.6056 16.3625C15.4059 16.7545 15.0872 17.0732 14.6952 17.2729C14.2495 17.5 13.6661 17.5 12.4993 17.5H7.49935C6.33257 17.5 5.74918 17.5 5.30354 17.2729C4.91153 17.0732 4.59282 16.7545 4.39309 16.3625C4.16602 15.9168 4.16602 15.3334 4.16602 14.1667V10C4.16602 9.22343 4.16602 8.83515 4.29288 8.52886C4.46204 8.12048 4.7865 7.79602 5.19488 7.62687C5.50116 7.5 5.88945 7.5 6.66602 7.5V7.5H7.08268"
          stroke="#6B6669"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector"
          d="M9.9987 12.5V2.5M9.9987 2.5L7.08203 5.41667M9.9987 2.5L12.9154 5.41667"
          stroke="#6B6669"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </g>
  </svg>
)

export default Share
